/**
 * Funnel step 3 (email capture), after pet-name and pet-photo, before
 * generation. Personalizes subtitle/button with [PET_NAME] from the shared
 * funnel state (same token pattern as pet-photo.js / generation-page.js).
 * Validates the email client-side, shows a loading state on submit,
 * persists the email + marketing choice into the shared funnel state (see
 * funnel-state.js — accumulates across every step), and only when the user
 * opted in, fires Shopify's native customer/newsletter form in the
 * background to create a real subscribed Customer. Never submits that
 * native form when consent isn't given, since it always sets
 * accepts_marketing = true.
 */
(() => {
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  document.querySelectorAll('[data-email-capture-form]').forEach((form) => {
    const input = form.querySelector('[data-email-capture-input]');
    const field = input.closest('.email-capture__field');
    const errorEl = form.querySelector('[data-email-capture-error]');
    const marketingInput = form.querySelector('[data-email-capture-marketing]');
    const submitBtn = form.querySelector('[data-email-capture-submit]');
    const buttonLabel = form.querySelector('[data-email-capture-button-label]');
    const subtitleEl = form.closest('.email-capture__card')?.querySelector('[data-email-capture-subtitle]');
    const nextUrl = form.dataset.nextUrl || '/pages/generando-preview';
    const defaultLabel = buttonLabel ? buttonLabel.textContent : '';

    const state = window.PfFunnel ? window.PfFunnel.get() : {};
    const petName = state.petName || 'ta mascotte';
    if (subtitleEl) subtitleEl.textContent = subtitleEl.textContent.replace('[PET_NAME]', petName);
    if (buttonLabel) buttonLabel.textContent = buttonLabel.textContent.replace('[PET_NAME]', petName);

    const nativeForm = document.getElementById('PfPreviewMarketingOptIn');
    const nativeEmailInput = nativeForm ? nativeForm.querySelector('[data-email-capture-native-email]') : null;

    // Pre-fill from a previous visit to this step (e.g. came back via the
    // header's back link) so nothing is lost, same pattern as pet-name.js.
    if (state.email) input.value = state.email;
    if (marketingInput && state.acceptsMarketing) marketingInput.checked = true;

    const showError = (message) => {
      field.classList.add('has-error');
      errorEl.textContent = message;
      errorEl.hidden = false;
    };

    const clearError = () => {
      field.classList.remove('has-error');
      errorEl.hidden = true;
      errorEl.textContent = '';
    };

    input.addEventListener('input', clearError);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const email = input.value.trim();

      if (!email) {
        showError('Merci de renseigner ton email.');
        input.focus();
        return;
      }

      if (!EMAIL_RE.test(email)) {
        showError('Cet email ne semble pas valide.');
        input.focus();
        return;
      }

      clearError();

      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
      if (buttonLabel) buttonLabel.textContent = 'Un instant…';

      const acceptsMarketing = !!(marketingInput && marketingInput.checked);

      window.PfFunnel.set({ email, acceptsMarketing });

      if (acceptsMarketing && nativeForm && nativeEmailInput) {
        nativeEmailInput.value = email;
        fetch(nativeForm.action, {
          method: 'POST',
          body: new FormData(nativeForm),
        }).catch(() => {
          // Best-effort: the funnel must not block on this.
        });
      }

      window.location.href = nextUrl;
    });
  });
})();
